import { FullProject, TaskWithSub } from 'entities';

import { Link, Dot } from 'components/Blocks';
import { WarningIcon } from 'components/Icons';

import { useProjectById } from 'providers/Project';

import { useAppWrapper } from '../../WrapperContext';

interface UserEntryProps {
  children?: never;
  entry: FullProject | TaskWithSub;
  shouldDisplayProjects: boolean;
  getStatusColor: (status: string) => string;
  addErrorIndicator?: boolean;
}

export function ProjectOrTask({
  entry,
  shouldDisplayProjects,
  getStatusColor,
  addErrorIndicator,
}: UserEntryProps) {
  const { escapeDrawer } = useAppWrapper();

  const project = useProjectById((entry as TaskWithSub).projectId || entry.id);

  const FIRST_LETTER = 0;

  const entryName = `${entry.name[FIRST_LETTER].toUpperCase()}${entry.name.slice(1)}`;

  const name = shouldDisplayProjects ? (
    entryName
  ) : (
    <>
      {entryName} <br />
      <span className="text-xxs">{project?.name}</span>
    </>
  );

  return (
    <Link
      className="flex items-center gap-3 pl-2 hover:underline"
      to="projectProfile"
      params={{ projectId: shouldDisplayProjects ? entry.id : (entry as TaskWithSub).projectId }}
      onClick={escapeDrawer}
    >
      {addErrorIndicator ? (
        <WarningIcon size={14} color={getStatusColor(entry.status)} />
      ) : (
        <Dot size={12} color={getStatusColor(entry.status)} />
      )}

      <span className="break-words text-start text-xs font-semibold">{name}</span>
    </Link>
  );
}
